import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

const FormikFileInput = ({ field, form }) => (
  <Input
    type="file"
    onChange={e => form.setFieldValue(field.name, e.target.files[0])}
  />
);

FormikFileInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default FormikFileInput;


// WEBPACK FOOTER //
// ./src/components/formik/FileInput.jsx